<template>
    <footer>
        <div class="wrapper">
            &copy; {{ new Date().getFullYear() }} Kilkenny College
        </div>
    </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
footer {
    background-color: var(--primary_colour);
    padding: 2rem 0;
    color: white;
}
</style>
